module.exports = __webpack_public_path__ + "static/media/particles.2a934e0d.jpg";